export const valueTransformers = {
  percentage(value: string | number) {
    if (typeof value === 'number') return value * 100;
    return value;
  },
};
